module.exports = __webpack_public_path__ + "static/media/brain-sketch7.4e3aad23.png";